const oneLetterWeekdaysJapanese = ["日", "月", "火", "水", "木", "金", "土"];

export default oneLetterWeekdaysJapanese;
